import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography, Checkbox, FormControlLabel } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import OtaSelectField from "./OtaSelectField";

const DropdownsByCategory = ({
  title,
  otaSelectFieldsProps,
  excludable,
  excludeSelection,
  setExcludeSelection,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Grid container item space={2} xs={12}>
      <Grid item xs={12} style={{ marginTop: theme.spacing(2) }}>
        <Typography variant="h6" style={{ fontSize: "1rem" }}>
          {t(`OTA.Filters.${title}`)}
        </Typography>
      </Grid>
      <Grid container item spacing={2} xs={12}>
        {otaSelectFieldsProps.map((otaSelectFieldProps) => (
          <OtaSelectField
            {...otaSelectFieldProps}
            key={otaSelectFieldProps.otaKey}
            exclude={excludeSelection}
          />
        ))}
      </Grid>
      {excludable && (
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={excludeSelection}
                value={excludeSelection}
                onChange={(_e, checked) => setExcludeSelection(checked)}
                name={`exclude_${title}`}
              />
            }
            label={t(`OTA.Filters.Exclude.${title}`)}
          />
        </Grid>
      )}
    </Grid>
  );
};

DropdownsByCategory.propTypes = {
  excludable: PropTypes.bool,
  excludeSelection: PropTypes.bool,
  setExcludeSelection: PropTypes.func,
  title: PropTypes.string.isRequired,
  otaSelectFieldsProps: PropTypes.arrayOf(PropTypes.shape(OtaSelectField.propTypes)),
};

DropdownsByCategory.defaultProps = {
  excludable: false,
  otaSelectFieldsProps: [],
  excludeSelection: false,
  setExcludeSelection: () => undefined,
};

export default DropdownsByCategory;
